// Questions d'écart avant de générer un dossier, même principe que la
// modale de l'extension (OfferQuestionsModal.tsx) : l'IA a repéré 2-3 écarts
// entre l'offre et le profil, on demande si le candidat a une expérience non
// mentionnée dans son CV. Répondre ou non ne change PAS la destination (le
// dossier se génère dans les deux cas), seulement ce que l'adaptation pourra
// valoriser. D'où une seule action mise en avant, jamais deux boutons qui
// donneraient l'impression d'un vrai choix.

import { useState } from 'react'
import { Sparkles } from 'lucide-react'
import { Modal, ActionButton } from './common'
import type { GapQuestion } from '../lib/api'
import { useMots } from '../lib/vocabulaire'
import { useT } from '../lib/i18n'

export function QuestionsEcart({
  questions,
  onSubmit,
  onSkip,
}: {
  questions: GapQuestion[]
  onSubmit: (reponses: { topic: string; question: string; detail: string }[]) => Promise<void>
  onSkip: () => void
}) {
  const mots = useMots()
  const t = useT()
  const [reponses, setReponses] = useState<string[]>(() => questions.map(() => ''))
  const remplies = reponses.filter((r) => r.trim()).length

  return (
    <Modal
      title={questions.length === 1 ? t('gapQuestions.titleOne') : t('gapQuestions.title', { n: questions.length })}
      onClose={onSkip}
      footer={
        <>
          <button className="btn-secondary" onClick={onSkip}>{t('gapQuestions.skip')}</button>
          <ActionButton
            variant="primary"
            busyLabel={t('gapQuestions.generating')}
            onClick={() =>
              onSubmit(
                questions.map((q, i) => ({ topic: q.topic, question: q.question, detail: reponses[i] ?? '' }))
              )
            }
          >
            <Sparkles size={15} />{mots('dossier.generer')}
          </ActionButton>
        </>
      }
    >
      <p className="field-help" style={{ marginBottom: 16 }}>
        {questions.length > 1 ? t('gapQuestions.introPlural') : t('gapQuestions.introSingular')}
      </p>
      {questions.map((q, i) => (
        <div key={i} style={{ marginBottom: 14 }}>
          <label className="field-label" htmlFor={`gap-q-${i}`}>
            <span style={{ color: 'var(--brand)' }}>{q.topic}.</span> {q.question}
          </label>
          <textarea
            id={`gap-q-${i}`}
            className="input-field"
            rows={2}
            value={reponses[i]}
            placeholder={t('gapQuestions.placeholder')}
            onChange={(e) => {
              const next = [...reponses]
              next[i] = e.target.value
              setReponses(next)
            }}
          />
        </div>
      ))}
      <p className="field-help" aria-live="polite">
        {remplies === 0
          ? t('gapQuestions.answeredNone')
          : remplies > 1
            ? t('gapQuestions.answeredPlural', { n: remplies })
            : t('gapQuestions.answeredSingular')}
      </p>
    </Modal>
  )
}
